import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const options = [
  { label: 'Cautelado', value: 'cautelary' },
  { label: 'Bem patrimonial', value: 'patrimonial' },
  { label: 'Locado', value: 'rented' },
  { label: 'Cedido', value: 'ceded' },
]

export const strategy = optionsToStrategy(options)
